import script from "./bannerSlide.vue?vue&type=script&lang=ts&setup=true"
export * from "./bannerSlide.vue?vue&type=script&lang=ts&setup=true"

import "./bannerSlider.scss?vue&type=style&index=0&id=a81aa354&lang=scss&scoped=true"
import "./bannerSliderElement.scss?vue&type=style&index=1&lang=scss"

import exportComponent from "/home/sergiy/projects/magnetics/promo.land/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a81aa354"]])

export default __exports__